import { render, staticRenderFns } from "./AudioSpace.vue?vue&type=template&id=541718d8&scoped=true"
import script from "./AudioSpace.vue?vue&type=script&lang=js"
export * from "./AudioSpace.vue?vue&type=script&lang=js"
import style0 from "./AudioSpace.vue?vue&type=style&index=0&id=541718d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541718d8",
  null
  
)

export default component.exports